
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import DashboardPage from './pages/Dashboard';
import LoginPage from './pages/Login';
import OrdersPage from './pages/Orders';
import BankAccountForm from './pages/BankAccountForm';
import AdControlForm from './pages/AdControlForm';
import BtcPrice from './pages/BtcPrice';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' Component={DashboardPage} />
        <Route path='/dashboard' Component={DashboardPage} />
        <Route path='/login' Component={LoginPage} />
        <Route path='/orders' Component={OrdersPage} />
        <Route path='/setpayment' Component={BankAccountForm} />
        <Route path='/setadcontrol' Component={AdControlForm} />
        <Route path='/btcprice' Component={BtcPrice} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
